module.exports = __webpack_public_path__ + "img/IMG-20190905-WA0022.4e69b7a6.jpg";